"use client";

import { Tab } from "rizzui";
import { useState } from "react";
import { Title } from "rizzui";
import ModalButton from "@/app/shared/modal-button";
import { CreateEditApiKey } from "@/app/app-shared/api-key/create-edit/create-edit-api-key";
import ApiKeyWrapper from "./ApiKeyWrapper";
import WebhookWrapper from "./WebhookWrapper";

export default function IntegrationsPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="mt-4">
      <div className="relative z-50 mb-4 flex flex-wrap items-center justify-between gap-2.5 @container">
        <Title as="h5" className="@xl:basis-auto text-xl md:text-2xl">
          Integrations
        </Title>
        {activeTab === 1 && (
          <ModalButton
            view={<CreateEditApiKey refetchData={() => {}} />}
            label="Add API Key"
            customSize="600px"
            className="mt-0 w-auto"
          />
        )}
      </div>

      <Tab selectedIndex={activeTab} onChange={(index) => setActiveTab(index)}>
        <Tab.List className="border-b border-gray-300">
          <Tab.ListItem>Webhook</Tab.ListItem>
          <Tab.ListItem>API Key</Tab.ListItem>
        </Tab.List>
        <Tab.Panels className="mt-6">
          <Tab.Panel>
            <WebhookWrapper />
          </Tab.Panel>
          <Tab.Panel>
            <ApiKeyWrapper />
          </Tab.Panel>
        </Tab.Panels>
      </Tab>
    </div>
  );
}
